import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { FormikTextField } from 'src/components/shared/form/formik/FormikTextField'
import { FormikRichTextEditor } from 'src/components/shared/form/formik/FormikRichTextEditor'
import { SectionCard } from 'src/components/shared/SectionCard'
import type { CustomerSettingsFormValues } from './CustomerSettingsForm.interface'

// Each screen is one group: its heading and the two fields sit 16px apart, and the groups sit
// 32px apart, so the eye reads three screens rather than one long run of fields.
const sectionStyles = tw`flex flex-col gap-4`

interface Props {
  isReadOnly: boolean
}

const OnboardingScreensCardComponent = ({ isReadOnly }: Props) => {
  return (
    <SectionCard
      title="Onboarding screens"
      subtitle="Text contractors see during and after onboarding."
    >
      <div css={tw`flex flex-col gap-8`}>
        <div css={sectionStyles}>
          <Typography variant="h5" css={tw`text-shades-1000`}>
            Success screen
          </Typography>
          <FormikTextField<CustomerSettingsFormValues>
            name="onboardingSuccessScreenTitle"
            label="Title"
            disabled={isReadOnly}
          />
          <FormikRichTextEditor<CustomerSettingsFormValues>
            name="onboardingSuccessScreenDescription"
            label="Message"
            readOnly={isReadOnly}
          />
        </div>

        <div css={sectionStyles}>
          <Typography variant="h5" css={tw`text-shades-1000`}>
            Delayed step screen
          </Typography>
          <FormikTextField<CustomerSettingsFormValues>
            name="onboardingDelayedStepTitle"
            label="Title"
            disabled={isReadOnly}
          />
          <FormikRichTextEditor<CustomerSettingsFormValues>
            name="onboardingDelayedStepDescription"
            label="Message"
            readOnly={isReadOnly}
          />
        </div>

        <div css={sectionStyles}>
          <Typography variant="h5" css={tw`text-shades-1000`}>
            Delayed step verbiage
          </Typography>
          <FormikTextField<CustomerSettingsFormValues>
            name="onboardingSuccessScreenDelayedTitle"
            label="Title"
            disabled={isReadOnly}
          />
          <FormikRichTextEditor<CustomerSettingsFormValues>
            name="onboardingSuccessScreenDelayedDescription"
            label="Message"
            readOnly={isReadOnly}
          />
        </div>
      </div>
    </SectionCard>
  )
}

export const OnboardingScreensCard = memo(OnboardingScreensCardComponent)
